import React from "react";

function OfficeBuildingIcon() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1010_97)" filter="url(#filter0_d_1010_97)">
        <path
          d="M13.2192 10.723V32H19.1567V28.1816H21.0317V32H26.6859V10.723H13.2192ZM17.2815 26.1645H15.4064V24.2886H17.2815V26.1645ZM17.2815 22.4124H15.4064V20.5364H17.2815V22.4124ZM17.2815 18.7466H15.4064V16.8707H17.2815V18.7466ZM17.2815 14.9945H15.4064V13.1186H17.2815V14.9945ZM21.0317 26.1645H19.1566V24.2886H21.0317V26.1645ZM21.0317 22.4124H19.1566V20.5364H21.0317V22.4124ZM21.0317 18.7466H19.1566V16.8707H21.0317V18.7466ZM21.0317 14.9945H19.1566V13.1186H21.0317V14.9945ZM24.782 26.1645H22.9069V24.2886H24.782V26.1645ZM24.782 22.4124H22.9069V20.5364H24.782V22.4124ZM24.782 18.7466H22.9069V16.8707H24.782V18.7466ZM22.9069 14.9945V13.1186H24.782V14.9945H22.9069Z"
          fill="#FFA83F"
        />
        <path
          d="M9.68687 26.2509V24.3749H11.3443V22.4987H9.68687V20.6228H11.3443V18.7466H9.68687V16.8707H11.3443V13.1186H4V14.9945H5.8875V32H11.3443V26.2509H9.68687Z"
          fill="#FFA83F"
        />
        <path
          d="M36 13.1186H28.561V16.8707H30.3132V18.7466H28.561V20.6228H30.3132V22.4987H28.561V24.3749H30.3132V26.2509H28.561V32H34.1125V14.9945H36V13.1186Z"
          fill="#FFA83F"
        />
        <path
          d="M28.5019 8.84706H30.8384V1.83031H21.3144V0H19.4394V1.83031H9.16162V8.84706H11.4982H28.5019ZM26.1554 3.96075H28.4361V4.67456H27.0853V5.00338H28.2717V5.68519H27.0853V6.05406H28.4882V6.76794H26.1554V3.96075ZM24.2231 3.89656C24.7722 3.89656 25.2051 4.09713 25.4817 4.458L24.8844 4.99137C24.7201 4.78281 24.5237 4.66256 24.2711 4.66256C23.8783 4.66256 23.6137 4.93525 23.6137 5.36438C23.6137 5.7935 23.8782 6.06612 24.2711 6.06612C24.5237 6.06612 24.7201 5.94581 24.8844 5.73731L25.4817 6.27075C25.2051 6.63163 24.7722 6.83219 24.2231 6.83219C23.3212 6.83219 22.6598 6.22662 22.6598 5.36444C22.6599 4.50213 23.3212 3.89656 24.2231 3.89656ZM21.9142 6.76794H20.9682V3.96075H21.9142V6.76794ZM17.9857 3.96075H20.2664V4.67456H18.9317V5.15581H20.1021V5.86969H18.9317V6.76794H17.9857V3.96075ZM15.0032 3.96075H17.2839V4.67456H15.9491V5.15581H17.1196V5.86969H15.9491V6.76794H15.0032V3.96075ZM11.0907 5.36438C11.0907 4.51419 11.7601 3.89663 12.674 3.89663C13.5879 3.89663 14.2573 4.51419 14.2573 5.36438C14.2573 6.2145 13.5879 6.83213 12.674 6.83213C11.7601 6.83213 11.0907 6.2145 11.0907 5.36438Z"
          fill="#FFA83F"
        />
        <path
          d="M13.3031 5.36438C13.3031 4.92725 13.0225 4.66257 12.6737 4.66257C12.325 4.66257 12.0444 4.92732 12.0444 5.36438C12.0444 5.8015 12.325 6.06613 12.6737 6.06613C13.0225 6.06613 13.3031 5.80144 13.3031 5.36438Z"
          fill="#FFA83F"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1010_97"
          x="0"
          y="0"
          width="40"
          height="40"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1010_97"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1010_97"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_1010_97">
          <rect width="32" height="32" fill="white" transform="translate(4)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default OfficeBuildingIcon;
